import { render, staticRenderFns } from "./MyCases.vue?vue&type=template&id=6b693956&"
import script from "./MyCases.vue?vue&type=script&lang=js&"
export * from "./MyCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports